var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-body" }, [
    _c(
      "div",
      { staticClass: "history-section" },
      [
        _c("page-limiter", [
          _c("h1", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.page.title))
          ]),
          _c("div", { staticClass: "history-section__body" }, [
            _c("div", { staticClass: "history-section__content" }, [
              _vm.page.items && _vm.page.items.length
                ? _c(
                    "ul",
                    { staticClass: "history-list" },
                    _vm._l(_vm.page.items, function(item) {
                      return _c("li", { staticClass: "history-list__item" }, [
                        _c("div", { staticClass: "history-list__item-head" }, [
                          item.image
                            ? _c("img", {
                                staticClass: "history-list__item-image",
                                attrs: { src: item.image, alt: "" }
                              })
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "history-list__item-body" }, [
                          _c(
                            "div",
                            { staticClass: "history-list__item-title" },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          _c(
                            "p",
                            { staticClass: "history-list__item-caption" },
                            [_vm._v(_vm._s(item.caption))]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm.page.items && _vm.page.items.length
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "swiper",
                          rawName: "v-swiper:historyCarousel",
                          value: _vm.historyCarouselOptions,
                          expression: "historyCarouselOptions",
                          arg: "historyCarousel"
                        }
                      ],
                      staticClass: "history-slider"
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "history-list swiper-wrapper" },
                        _vm._l(_vm.page.items, function(item) {
                          return _c(
                            "li",
                            { staticClass: "history-list__item swiper-slide" },
                            [
                              _c(
                                "div",
                                { staticClass: "history-list__item-head" },
                                [
                                  item.image
                                    ? _c("img", {
                                        staticClass: "history-list__item-image",
                                        attrs: { src: item.image, alt: "" }
                                      })
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "history-list__item-body" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "history-list__item-title" },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "history-list__item-caption"
                                    },
                                    [_vm._v(_vm._s(item.caption))]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _c("div", {
                        staticClass: "swiper-scrollbar",
                        attrs: {
                          "data-start": _vm.page.items[0].title,
                          "data-end":
                            _vm.page.items[_vm.page.items.length - 1].title
                        }
                      })
                    ]
                  )
                : _vm._e()
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a745722", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a745722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageHistory.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1a745722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageHistory.vue
// module chunks = 0